module.exports = __webpack_public_path__ + "static/media/displaypic.1dce413b.jpg";